import { SESSION_STORAGE_ACCOUNT_KEY, SESSION_STORAGE_CLIENTINFO_KEY, SESSION_STORAGE_UTM_DATA } from './sessionStorage'
const covrServicesUrl = window.__ENV__.REACT_APP_COVR_SERVICES_URL

async function saveSessionEvent(submitted, handoffPath = '', partnerReferralModalOpened) {
  let pathname = window && window.location && window.location.pathname
  if (handoffPath !== "") {
      pathname = handoffPath;
  }
  const account = JSON.parse(sessionStorage.getItem(SESSION_STORAGE_ACCOUNT_KEY));

  let sessionLogExtraParams = '';

  if (window.location.href.includes("DataImport")) {
    var clientInfoObj = sessionStorage.getItem(SESSION_STORAGE_CLIENTINFO_KEY);
    if (clientInfoObj) {
      const clientInfo = JSON.stringify(JSON.parse(clientInfoObj).value);
      sessionLogExtraParams = `&DataImport=${clientInfo}`;
    }
  }

  if (submitted === true) {
      sessionLogExtraParams = `${sessionLogExtraParams}&Submitted=true`;
  }

  if (partnerReferralModalOpened === true) {
    sessionLogExtraParams = `${sessionLogExtraParams}&PartnerReferral=true`;
  }

  const utmData = sessionStorage.getItem(SESSION_STORAGE_UTM_DATA);
  const utmString = utmData ? utmData
    .substring(1, utmData.length - 1)
    .split(", ")
    .map(item => {
      let arr = item.split("=");
      return `{"${arr[0]}":"${arr[1]}"}`;
    })
    .join(",") : "";
  const utmQueryString = utmData ? `&UtmData=[${encodeURIComponent(utmString)}]`: "";

  if (account != null) {
    let sessionId = account.value.sessionId;
   
    const x = fetch(`${covrServicesUrl}/api/Session?SessionId=${sessionId}&Pathname=${pathname}${sessionLogExtraParams}${utmQueryString}`, {
      method: 'GET'
    })
      .then(x => x.json())

    return x
  }
}

export { saveSessionEvent }
